import { Component, OnInit, HostListener } from '@angular/core';

import { MatDialog } from '@angular/material';
import { HelperService } from '../app/core/services/helper.service';
import { appVariables } from '../app/core/constants/Common.constant';
import { environment } from '../environments/environment';
import { ShoppingService } from '../app/core/services/shopping.service';
import { AutoLogOutDialogComponent } from '../app/shoppingcart/auto-log-out-dialog/auto-log-out-dialog.component';
import { UserModel } from '../app/core/models/ShoppingCart.model';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  // public loading = true;

  intervalId: any;
  dialogRef: any;
  isWindowActive = true;
  userDetails: UserModel;
  Counter: any;
  useraccountid: any;
  checkCounterVal: any;
  IsDialogActive: any;
  token: any;
  IsUserActive: boolean;
  tokenUser: any
  IsGUID: any
  isLTI: any;
  constructor(public dialog: MatDialog, private helperService: HelperService, private shoppingService: ShoppingService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.isLTI = params['isLTI'];
      if (this.isLTI != undefined && this.isLTI != null && this.isLTI == '1') {
        this.shoppingService.setIsLTI(true);
      }
    });

    this.helperService.setToLocalStorage(appVariables.SessionCounter, '0');
    this.setTimer();
    this.IsDialogActive = false;
    this.shoppingService.SetTimerCall.subscribe(isValid => {
      this.IsDialogActive = false;
      this.dialog.closeAll();
      clearInterval(this.intervalId);
      this.setTimer();
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClicked($event) {
    if ($event.target.id === '' && $event.target.id !== 'btnContinueSession' && this.IsDialogActive === false) {
      this.checkTimerandToken();
    }
  }


  @HostListener('document:mouseover', ['$event'])
  onmouseover($event) {
    if ($event.target.id === '' && $event.target.id !== 'btnContinueSession' && this.IsDialogActive === false) {
      this.checkTimerandToken();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    if ($event.target.id === '' && $event.target.id !== 'btnContinueSession' && this.IsDialogActive === false) {
      this.checkTimerandToken();
    }
  }

  @HostListener('window:blur', ['$event'])
  onBlur($event) {
    if ($event.target.id === '' && $event.target.id !== 'btnContinueSession' && this.IsDialogActive === false) {
      this.checkTimerandToken();
    }
  }

  @HostListener('window:focus', ['$event'])
  onFocus($event) {
    if ($event.target.id === '' && $event.target.id !== 'btnContinueSession' && this.IsDialogActive === false) {
      this.checkTimerandToken();
    }
  }

  checkTimerandToken() {
    // debugger;
    if (this.checkCounterVal < environment.SessionTimeoutPopUp && (this.tokenUser !== '' || this.IsUserActive)) {
      clearInterval(this.checkCounterVal);
      this.setTimer();
    }
    // if (this.tokenUser !== '' || this.IsUserActive) {
    //   this.shoppingService.AutoLogOut.emit(true);
    // }
  }

  setTimer() {
    //  this.userDetails = this.helperService.getUserFromLocalStorage();
    this.helperService.setToLocalStorage(appVariables.SessionCounter, '0');
    clearInterval(this.intervalId);
    this.Counter = this.helperService.getFromLocalStorage(appVariables.SessionCounter) ?
      Number(this.helperService.getFromLocalStorage(appVariables.SessionCounter)) : 0;

    // this.token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
    //  debugger;
    this.activatedRoute.queryParams.subscribe(params => {
      this.useraccountid = params['accountid'];
      this.useraccountid = this.useraccountid == undefined ? 0 : this.useraccountid;
      this.IsUserActive = (this.useraccountid !== 0) ? true : false;
      this.helperService.setToLocalStorage(appVariables.IsUserActive, this.useraccountid);
    });

    this.intervalId = setInterval(() => {
      this.Counter = this.Counter + 1;
      this.checkCounterVal = this.Counter;
      this.helperService.setToLocalStorage(appVariables.SessionCounter, this.Counter.toString());
      // this.activatedRoute.queryParams.subscribe(params => {
      //   this.useraccountid = params['accountid'];
      //   this.useraccountid = this.useraccountid == undefined ? 0 : this.useraccountid;
      // });

      this.tokenUser = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
      // if (this.helperService.getFromLocalStorage(appVariables.IsUserActive)) {
      if (this.tokenUser !== '' || this.IsUserActive) {
        if (this.Counter < environment.SessionTimeoutPopUp) {
          this.IsDialogActive == false;
        }
        if (this.Counter === environment.SessionTimeoutPopUp) {
          this.IsDialogActive = true;
          this.dialogRef = this.dialog.open(AutoLogOutDialogComponent, {
            disableClose: true,
            hasBackdrop: true, // or false, depending on what you want
            maxWidth: '800px',
            position: { top: '40px' },
            //  panelClass: 'clsAutoLogOutPopUp',
            data: {
            }
          });

        }
        if (this.Counter === environment.sessionTimeout) {
          this.IsDialogActive == false;
          this.dialog.closeAll();
          clearInterval(this.intervalId);
          this.shoppingService.AutoLogOut.emit(true);
        }
      }
      else {
        this.activatedRoute.queryParams.subscribe(params => {
          this.IsGUID = params['GUID'];
        });
        if (this.IsGUID === '') {
          this.IsDialogActive == false;
          this.dialog.closeAll();
          clearInterval(this.intervalId);
          this.shoppingService.AutoLogOut.emit(true);
        }
      }

    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts